import { msg } from '@lingui/core/macro';

import { COMPLETION_METHOD } from '../../../___shared___/constants.ts';

export { COMPLETION_METHOD };

export const MY_LEARNING_DATA_INDEX = {
    PATHWAY: 'title',
    DATE: 'stateUpdateDateUTC',
    RANK: 'rank',
    LOCATION: 'locationName',
    SCORE: 'scorePercent',
    ATTEMPT: 'finalQuizAttemptNumber',
    STATUS: 'status',
    METHOD: 'completionMethod',
    CERTIFICATE: 'hasCertificate',
} as const;

export const MY_LEARNING_COLUMN_TITLE = {
    PATHWAY: msg`Pathway`,
    DATE: msg`Date`,
    RANK: msg`Title (Rank)`,
    LOCATION: msg`Location`,
    SCORE: msg`Score (%)`,
    ATTEMPT: msg`Attempt No.`,
    STATUS: msg`Status`,
    METHOD: msg`Method`,
    CERTIFICATE: msg`Cert.`,
} as const;

export const MY_LEARNING_COLUMN_SORT_MAP: Record<string, string> = {
    [MY_LEARNING_DATA_INDEX.PATHWAY]: 'Title',
    [MY_LEARNING_DATA_INDEX.DATE]: 'StateUpdateDateUTC',
    [MY_LEARNING_DATA_INDEX.RANK]: 'Rank',
    [MY_LEARNING_DATA_INDEX.LOCATION]: 'LocationName',
    [MY_LEARNING_DATA_INDEX.SCORE]: 'ScorePercent',
    [MY_LEARNING_DATA_INDEX.ATTEMPT]: 'FinalQuizAttemptNumber',
    [MY_LEARNING_DATA_INDEX.STATUS]: 'Status',
    [MY_LEARNING_DATA_INDEX.METHOD]: 'CompletionMethod',
    [MY_LEARNING_DATA_INDEX.CERTIFICATE]: 'HasCertificate',
};

export const MY_LEARNING_COLUMN_FILTER_REQUEST_MAP: Record<string, string> = {
    [MY_LEARNING_DATA_INDEX.PATHWAY]: 'Title',
    [MY_LEARNING_DATA_INDEX.RANK]: 'Rank',
    [MY_LEARNING_DATA_INDEX.LOCATION]: 'LocationName',
    [MY_LEARNING_DATA_INDEX.STATUS]: 'Status',
    [MY_LEARNING_DATA_INDEX.METHOD]: 'CompletionMethod',
};

export const DEFAULT_FINAL_QUIZ_MAX_ATTEMPTS = 3;

export const PENDING_CERTIFICATE_NAME = 'certificatePending';
export const CERTIFICATE_URL_NAME = 'certificateURL';

export const MY_LEARNING_SORT_MAP = MY_LEARNING_COLUMN_SORT_MAP;
